module.exports={render:function (){with(this) {
  return _h('div', {
    attrs: {
      "id": "app"
    }
  }, [_m(0), " ", _h('hello'), " ", _m(1), " ", _m(2), " ", _m(3)])
}},staticRenderFns: [function (){with(this) {
  return _h('img', {
    staticClass: "logo",
    attrs: {
      "src": require("./assets/logo.png")
    }
  })
}},function (){with(this) {
  return _h('p', ["\n    Welcome to your Vue.js app!\n  "])
}},function (){with(this) {
  return _h('p', ["\n    To get a better understanding of how this boilerplate works, check out\n    ", _h('a', {
    attrs: {
      "href": "http://vuejs-templates.github.io/webpack",
      "target": "_blank"
    }
  }, ["its documentation"]), ".\n    It is also recommended to go through the docs for\n    ", _h('a', {
    attrs: {
      "href": "http://webpack.github.io/",
      "target": "_blank"
    }
  }, ["Webpack"]), " and\n    ", _h('a', {
    attrs: {
      "href": "http://vuejs.github.io/vue-loader/",
      "target": "_blank"
    }
  }, ["vue-loader"]), ".\n    If you have any issues with the setup, please file an issue at this boilerplate's\n    ", _h('a', {
    attrs: {
      "href": "https://github.com/vuejs-templates/webpack",
      "target": "_blank"
    }
  }, ["repository"]), ".\n  "])
}},function (){with(this) {
  return _h('p', ["\n    You may also want to checkout\n    ", _h('a', {
    attrs: {
      "href": "https://github.com/vuejs/vue-router/",
      "target": "_blank"
    }
  }, ["vue-router"]), " for routing and\n    ", _h('a', {
    attrs: {
      "href": "https://github.com/vuejs/vuex/",
      "target": "_blank"
    }
  }, ["vuex"]), " for state management.\n  "])
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
 ** module id = 8
 ** module chunks = 1
 **/